import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://www.pvsolar.energy";

// Per-route head tags. With react-snap these get baked into each route's
// static HTML at build time, so crawlers see them without running JS.
export default function Seo({ title, description, path }) {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={`${SITE}${path}`} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={`${SITE}${path}`} />
        </Helmet>
    );
}
